    angular.module('qkr').factory('defaultPatProductsService', defaultPatProductsService);

    defaultPatProductsService.$inject = ['appConfig', '$http'];

    function defaultPatProductsService(appConfig, $http) {
        return {
            getProductsForDefaults: (outletId) => $http.get(appConfig.apiUrl + 'productGroup/' + outletId
                + '/getProductsForDefaults', {withCredentials: true}).then(response => response.data)
            , getProductsForDefaultsBarTab: (outletId) => $http.get(appConfig.apiUrl + 'productGroup/' + outletId
                + '/getProductsForDefaultsBarTab', {withCredentials: true}).then(response => response.data)

            , updateDefaultProduct: (defaultProductUpdateCommand) => $http.post(appConfig.apiUrl +
                'productGroup/updateDefaultProduct', defaultProductUpdateCommand, {withCredentials: true})
                .then(response => response.data)
            , saveRoundNumber: (defaultProductUpdateCommand) => $http.post(appConfig.apiUrl +
                'productGroup/saveRoundNumber', defaultProductUpdateCommand, {withCredentials: true})
                .then(response => response.data)
        };
    }



// WEBPACK FOOTER //
// ./src/default-products/services/default.pat.products.service.js